/**
 * Grass Gone Wild — Border Glow Hover Effect (Ultra-Optimized)
 * Tracks pointer coordinates and updates CSS variables for cursor-centered radial border glows.
 * Runs at 120 FPS, completely preventing layout thrashing and container bleed-through.
 */

export function initBorderGlow() {
  const cards = document.querySelectorAll('.service-showcase-panel, .staggered-col-inner');
  if (cards.length === 0) return;

  cards.forEach(card => {
    // 1. Structure elements to preserve correct layout stacking
    if (!card.classList.contains('border-glow-card')) {
      const inner = document.createElement('div');
      inner.className = 'border-glow-inner';
      
      // Move card contents to inner container
      while (card.firstChild) {
        inner.appendChild(card.firstChild);
      }
      card.appendChild(inner);
      card.classList.add('border-glow-card');

      // Configure border radius properties based on card types
      const isShowcase = card.classList.contains('service-showcase-panel');
      const borderRadius = isShowcase ? 24 : 20;
      card.style.setProperty('--border-radius', `${borderRadius}px`);
    }

    let rect = null;

    // Cache bounding client rect only once on entry to avoid layout thrashing
    card.addEventListener('pointerenter', () => {
      rect = card.getBoundingClientRect();
    });

    card.addEventListener('pointerleave', () => {
      rect = null;
    });

    // Handle mouse movement to update coordinates
    card.addEventListener('pointermove', (e) => {
      if (!rect) {
        rect = card.getBoundingClientRect();
      }
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;

      card.style.setProperty('--cursor-x', `${x}px`);
      card.style.setProperty('--cursor-y', `${y}px`);
    });
  });
}
